<template>
    <div id="cal"></div>
</template>
<script>
export default {
    props: ['data'],
    data () {
        return {
            cal: null
        }
    },
    methods: {

    },
    mounted () {
        var _this = this;
        this.cal = $(_this.$el);
           
        var args = {
	        lang: 'en',
            header: {
                left:   'prev,next today',
                center: 'title',
                right:  'month,agendaWeek,agendaDay'
            },
            height: "auto",
            allDaySlot: false,
            slotEventOverlap: false,
            timeFormat: null,
            events: this.data,
            eventOrder: "id",
            eventClick (data) {                
      	        _this.$parent.getDocs(data);
            }
        };
        this.cal.fullCalendar(args);
    }

}
</script>
<style scoped>
span.fc-time {
    display: none;
}
</style>
